import {
  AuthSlice,
  ClientConfigSlice,
  logoutListenerMiddleware,
} from '@framework/auth';
import { configureStore } from '@reduxjs/toolkit';

export const store = configureStore({
  reducer: {
    auth: AuthSlice.reducer,
    clientConfig: ClientConfigSlice.reducer,
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware().prepend(logoutListenerMiddleware.middleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
